// extracted by mini-css-extract-plugin
export var btnAIContainer = "LessonPage-module--btnAIContainer--6384d";
export var buttonAI = "LessonPage-module--buttonAI--0ce26";
export var buttonAIMobile = "LessonPage-module--buttonAIMobile--f33d9";
export var descriptionAIContainer = "LessonPage-module--descriptionAIContainer--550a3";
export var descriptionAIMobile = "LessonPage-module--descriptionAIMobile--7573d";
export var flexWrapper = "LessonPage-module--flexWrapper--fc25c";
export var iconAI = "LessonPage-module--iconAI--cd5b8";
export var newFeatContainer = "LessonPage-module--newFeatContainer--f7d15";
export var newFeatContainerMobile = "LessonPage-module--newFeatContainerMobile--53109";
export var newFeatDescription = "LessonPage-module--newFeatDescription--297ad";
export var newFeatTitle = "LessonPage-module--newFeatTitle--b8648";
export var ondemandWrapper = "LessonPage-module--ondemandWrapper--96f45";
export var relatedLessonItemContainer = "LessonPage-module--relatedLessonItemContainer--7639c";
export var relatedLessonsWrapper = "LessonPage-module--relatedLessonsWrapper--dfd2a";
export var sectionPopover = "LessonPage-module--sectionPopover--cd6fd";
export var subtitleContent = "LessonPage-module--subtitleContent--f629f";
export var titleH1Intro = "LessonPage-module--titleH1Intro--d102e";
export var titleH2Content = "LessonPage-module--titleH2Content--29646";